module.exports = __webpack_public_path__ + "/i18n/messages/es_419.json";